module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      fontSize: _vm.fontSize + 'px'
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Portfolio of JavaScript & Python Industy-Inspired, Curriculum-Based Projects")]), _vm._v(" "), _c('mainNavComponent')], 1), _vm._v(" "), _c('section', {
    staticClass: "route"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_vm._m(1), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fontSizeChange_Section"
  }, [_c('button', {
    staticClass: "button fontSizeChange_Button",
    on: {
      "click": function($event) {
        _vm.fontSize--
      }
    }
  }, [_vm._v("\n      Font Size: -\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "button fontSizeChange_Button",
    on: {
      "click": function($event) {
        _vm.fontSize++
      }
    }
  }, [_vm._v("\n      Font Size: +\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "fontSizeChange_TextStatus",
    style: ([_vm.fontSizeChange_00_Style, _vm.fontSizeChange_01_Style, {
      fontSize: _vm.fontSize + 'px'
    }])
  }, [_vm._v("\n      Font Size: " + _vm._s(_vm.fontSize) + "\n    ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerUpper"
  }, [_c('h1', [_vm._v("Jason W Chan")]), _vm._v(" "), _c('h2', [_vm._v("Web Full-Stack & Robotics Instructor / Developer")]), _vm._v(" "), _c('h2', [_vm._v("Primary, Secondary & Collegiate Ed")]), _vm._v(" "), _c('h4', [_vm._v("jasonc@eande.world, mobile/text 408-828-5131, "), _c('a', {
    staticClass: "urlLink",
    attrs: {
      "href": "https://www.linkedin.com/in/jasonwchan1025/",
      "target": "_blank"
    }
  }, [_vm._v("www.linkedin.com/in/jasonwchan1025/")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "Creative Commons License",
      "src": "https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"
    }
  }), _vm._v("   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_vm._v("Portfolio developed by Jason W Chan using Vue.js, Node.js & Netlify "), _c('br'), _vm._v(" Creative Commons Attribution-NonCommercial-ShareAlike "), _c('br'), _vm._v(" 4.0 International License")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 120
// module chunks = 1